/**
 * Fallback PayPal browser SDK client id (public).
 * Prefer the active store's paypal_client_id from the API when booking.
 */
export const PAYPAL_CLIENT_ID =
	import.meta.env.VITE_PAYPAL_CLIENT_ID ||
	'ARni4L2au2UrJiQ5MAhZ6x1DvU45y39H5absAGCtNNwdFdY412pOlCzWr8gB9ejNQym5LsiBC0WzTvP5'

const PAYPAL_SCRIPT_BASE = {
	currency: 'EUR',
	intent: 'capture',
	locale: 'de_DE',
	components: 'buttons,applepay,messages',
	enableFunding: 'paylater',
	disableFunding: 'credit,card,giropay,sepa',
} as const

/**
 * Shared PayPal JS SDK options for booking checkout / extend.
 * Pass storeClientId from the active store when available.
 */
export const getPayPalScriptOptions = (storeClientId?: string | null) =>
	({
		...PAYPAL_SCRIPT_BASE,
		clientId: storeClientId || PAYPAL_CLIENT_ID,
	}) as const

/** @deprecated Prefer getPayPalScriptOptions(store.paypal_client_id) */
export const PAYPAL_SCRIPT_OPTIONS = getPayPalScriptOptions()

/** Pay Later banner from PayPal's messaging generator: flex 20x1, white no border. */
export const PAYPAL_MESSAGE_STYLE = {
	layout: 'flex' as const,
	ratio: '20x1' as const,
	color: 'white-no-border',
}

export const PAYPAL_MESSAGE_PLACEMENT = 'home' as const

export const PAYPAL_BUTTON_STYLE = {
	layout: 'vertical' as const,
	color: 'white' as const,
	disableMaxWidth: true,
	borderRadius: 12,
}
